import RequestManager from "../../API";
import api from "../../utils/api";
import { setLoading, storeGetCustomer } from "./commonActions";

export const getCustomerData = (query?: string) => async (dispatch: any) => {
    const response: any = await RequestManager.getRequest(
        dispatch,
        api.GET_CUSTOMER,
        '',
        query
    );
    if (response) {
        dispatch(storeGetCustomer(response?.data[0]));
        dispatch(setLoading(false));
    }
}



export const UpdateCustomerInfo = (params?: any) => async (dispatch: any) => {
    const response: any = await RequestManager.putRequest(
        dispatch,
        api.PUT_CUSTOMER,
        params,
        '',
        '',
       
    );
    if (response) {
        const CustomerData: any = response.data;
        //   dispatch(storeGetCustomer(CustomerData[0]));
    } else {
    }
}
// getCustomerOrder
export const getCustomerOrder = (params?: any) => async (dispatch: any) => {
    const response: any = await RequestManager.getRequest(
        dispatch,
        api.GET_CUSTOMER_ORDER,
        '',
        params
    );
    if (response) {
        const CustomerOrderData: any = response;
        return CustomerOrderData
    } else {
    }
}
//getOrders
export const getOrders = (params?: any,header?:any) => async (dispatch: any) => {
    const response: any = await RequestManager.getRequest(
        dispatch,
        api.GET_ORDERS,
        '',
        params,
        header
    );
    if (response) {
        const CustomerOrderData: any = response;
        return CustomerOrderData
    } else {
    }
}